import {postRequest} from "../api";
import {mapReqOptions} from "../utils";

export const getUsersList = (query, options) => {
  const reqData = {
    query,
    ...mapReqOptions(options)
  };

  const {
    limit,
    offset = 0,
    sort_by = "user-name",
    sort_order = "asc",
    query: q
  } = reqData;

  return postRequest(
    query === "*"
      ? `/iroh/user-mgmt/search/users?limit=${limit}&offset=${offset}&sort_by=${sort_by}&sort_order=${sort_order}`
      : `/iroh/user-mgmt/search/users?limit=${limit}&sort_by=${sort_by}&sort_order=${sort_order}&match=${q}`,
    {
      "enabled?": true
    },
    {serverOptions: {publicURL: false}}
  );
};
